import { API_URL, GETAPI } from "./config";

export const GET_GALLERY = async () => {
  const res = await GETAPI(API_URL.getGallery);
  return res;
};
